import React from "react";
import "./_format-slider.scss";
import FormatTile from "../../../../atoms/search-bar-filter-components/format/format-tile/format-tile";
import {useSelector} from "react-redux";
import {RootState} from "../../../../../store/configureStore";
import {Config} from '../../../../../constants/Config';

const baseClass = 'clubFinder-formatSlider'

interface FormatSliderPropTypes {
  formatDetailsObject: any
  handleNextButton?: any
  setSelectedFormat?: any
  removeSelectedFormat?: any
}

const FormatSlider = (props: FormatSliderPropTypes): JSX.Element => {
  const AllFormatLogo = useSelector((state: RootState) => state.widgetConfigurationSettings.allFormatsIcon);
  const formatList = props.formatDetailsObject.map((formatDetail: any, index: number) =>
    <FormatTile formatLogo={formatDetail.logo} formatTitle={formatDetail.name} key={index}
                setSelectedFormat={(formatObject: any, formatTitle: any) => props.setSelectedFormat(formatObject, formatTitle)}
                playHqFormats={formatDetail.playHqFormats}
                removeSelectedFormat={(removedFormatKey: string, removedFormatTitle: any) => props.removeSelectedFormat(removedFormatKey, removedFormatTitle)}/>
  );

  return (
    <div className={`${baseClass}`}>
      <div className={`${baseClass}-slider-content`}>
        <FormatTile formatLogo={AllFormatLogo ? AllFormatLogo : null} formatTitle={Config.defaultFormatOption.name} formatLogoStyles={'all-format-logo'}
                    setSelectedFormat={(formatObject: any, formatTitle: any) => props.setSelectedFormat(formatObject, formatTitle)}
                    playHqFormats={Config.defaultFormatOption.playHqFormats}
                    removeSelectedFormat={(removedFormatKey: string, removedFormatTitle: any) => props.removeSelectedFormat(removedFormatKey, removedFormatTitle)}/>
        {formatList}
      </div>
      <div className={`${baseClass}--button-container`}>
        <div className={`${baseClass}--button-container-button-text`} onClick={props.handleNextButton}>
          Next
        </div>
      </div>
    </div>
  )
}

export default FormatSlider;
